export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  SCHOOL_OWNER: 'school_owner',
  SCHOOL_ADMIN: 'school_admin',
};

export const CONTACT_TYPES = [
  { value: 'student', text: 'Student' },
  { value: 'employer', text: 'Employer' },
  { value: 'lead', text: 'Lead' },
  { value: 'other', text: 'Other' },
];

export const CONTACT_SOURCES = [
  { value: 'manual', text: 'Manual' },
  { value: 'imported_transition', text: 'Imported (Transition)' },
  { value: 'imported_enroll', text: 'Imported (TransitionEnroll)' },
  { value: 'website', text: 'Website' },
];

export const EMAIL_TEMPLATE_CATEGORIES = [
  { value: 'enrollment', text: 'Enrollment' },
  { value: 'marketing', text: 'Marketing' },
  { value: 'follow_up', text: 'Follow Up' },
  { value: 'general', text: 'General' },
];

export const CAMPAIGN_STATUSES = [
  { value: 'draft', text: 'Draft' },
  { value: 'scheduled', text: 'Scheduled' },
  { value: 'sending', text: 'Sending' },
  { value: 'sent', text: 'Sent' },
  { value: 'failed', text: 'Failed' },
];

export const CONTRACT_STATUSES = [
  { value: 'draft', text: 'Draft' },
  { value: 'sent', text: 'Sent' },
  { value: 'viewed', text: 'Viewed' },
  { value: 'signed', text: 'Signed' },
  { value: 'expired', text: 'Expired' },
  { value: 'voided', text: 'Voided' },
];

export const TEMPLATE_VARIABLES = [
  '{{FIRST_NAME}}',
  '{{LAST_NAME}}',
  '{{FULL_NAME}}',
  '{{EMAIL}}',
  '{{PHONE}}',
  '{{SCHOOL_NAME}}',
];

export const AUTOMATION_TRIGGER_TYPES = [
  { value: 'stage_change', text: 'Stage Change' },
  { value: 'contact_created', text: 'Contact Created' },
  { value: 'tag_added', text: 'Tag Added' },
  { value: 'tag_removed', text: 'Tag Removed' },
  { value: 'contract_signed', text: 'Contract Signed' },
];

export const AUTOMATION_ACTION_TYPES = [
  { value: 'send_email', text: 'Send Email' },
  { value: 'send_sms', text: 'Send SMS' },
  { value: 'send_contract', text: 'Send Contract' },
  { value: 'send_survey', text: 'Send Survey' },
  { value: 'update_stage', text: 'Update Stage' },
  { value: 'add_tag', text: 'Add Tag' },
  { value: 'remove_tag', text: 'Remove Tag' },
  { value: 'create_note', text: 'Create Note' },
];

export const STAGE_FIELDS = [
  { value: 'lead_stage', text: 'Lead Stage' },
  { value: 'student_stage', text: 'Student Stage' },
  { value: 'employer_stage', text: 'Employer Stage' },
  { value: 'other_stage', text: 'Other Stage' },
];

export const LEAD_STAGES = [
  { value: 'new_inquiry', text: 'New Inquiry' },
  { value: 'contacted', text: 'Contacted' },
  { value: 'engaged', text: 'Engaged' },
  { value: 'qualified', text: 'Qualified' },
  { value: 'info_session_booked', text: 'Info Session Booked' },
  { value: 'info_session_attended', text: 'Info Session Attended' },
  { value: 'application_started', text: 'Application Started' },
  { value: 'application_completed', text: 'Application Completed' },
  { value: 'approved', text: 'Approved' },
  { value: 'payment_pending', text: 'Payment Pending' },
  { value: 'converted_to_student', text: 'Converted to Student' },
  { value: 'disqualified', text: 'Disqualified' },
  { value: 'cold', text: 'Cold' },
  { value: 'stopped', text: 'Stopped' },
];

export const STUDENT_STAGES = [
  { value: 'enrolled', text: 'Enrolled' },
  { value: 'class_started', text: 'Class Started' },
  { value: 'in_progress', text: 'In Progress' },
  { value: 'past_due', text: 'Past Due' },
  { value: 'on_leave', text: 'On Leave' },
  { value: 'withdrawn', text: 'Withdrawn' },
  { value: 'completed', text: 'Completed' },
  { value: 'graduated', text: 'Graduated' },
  { value: 'certified', text: 'Certified' },
  { value: 'placed', text: 'Placed' },
  { value: 'alumni', text: 'Alumni' },
];

export const EMPLOYER_STAGES = [
  { value: 'prospect', text: 'Prospect' },
  { value: 'contacted', text: 'Contacted' },
  { value: 'intro_call_completed', text: 'Intro Call Completed' },
  { value: 'partnership_discussion', text: 'Partnership Discussion' },
  { value: 'active_partner', text: 'Active Partner' },
  { value: 'hiring', text: 'Hiring' },
  { value: 'clinical_partner', text: 'Clinical Partner' },
  { value: 'placement_complete', text: 'Placement Complete' },
  { value: 'inactive', text: 'Inactive' },
];

export const OTHER_STAGES = [
  { value: 'new', text: 'New' },
  { value: 'active', text: 'Active' },
  { value: 'inactive', text: 'Inactive' },
  { value: 'archived', text: 'Archived' },
];

export const QUESTION_TYPES = [
  { value: 'boolean', text: 'Yes / No' },
  { value: 'short_text', text: 'Short Text' },
  { value: 'long_text', text: 'Long Text' },
  { value: 'single_select', text: 'Single Select' },
  { value: 'multi_select', text: 'Multi Select' },
  { value: 'file_type', text: 'File Upload' },
];

export const SURVEY_STATUSES = [
  { value: 'draft', text: 'Draft' },
  { value: 'active', text: 'Active' },
  { value: 'closed', text: 'Closed' },
  { value: 'archived', text: 'Archived' },
];
